module.exports = __webpack_public_path__ + "media/brands/polski-fiat-41bceafe.png";